import { useFetchTimelineStudyRecords } from "../../hooks/http/useFetchTimelineStudyRecords";
import { useMergedTimeline } from "../../hooks/useMergedTimeline";
import { useTimelineDrillProgress } from "../../hooks/useTimelineDrillProgress";

type Props = {
  sectionId: string;
  studentId: string;
  enabled: boolean;
};

// 生徒個別タイムラインの統合ストリーム。
// AI 質問統合表示の凍結（005-freeze-ai-question-timeline）に伴い、学習記録ソースのみを扱う。
// 校舎リアルタイムタブ（useMergedRealtimeTimeline）を「特定の生徒に絞り込んだ」もので、
// 学習記録ソースを student_id 付きで取得し、無限スクロール・エラー局所化は共通フック
// useMergedTimeline に委譲する。
export const useMergedStudentTimeline = ({
  sectionId,
  studentId,
  enabled,
}: Props) => {
  // 単一生徒のページのため StudentFilter（job/status/tag_ids/smart_tag）は使わない。
  // 生徒の絞り込みは student_id で行う。
  const studyQuery = useFetchTimelineStudyRecords({
    sectionId,
    studentId,
    queryParams: {},
    enabled,
  });

  const { displayed, isLoading, isFetchingNextPage } = useMergedTimeline({
    studySource: {
      items: studyQuery.data ?? [],
      hasNextPage: !!studyQuery.hasNextPage,
      isFetchingNextPage: studyQuery.isFetchingNextPage,
      fetchNextPage: studyQuery.fetchNextPage,
      isLoading: studyQuery.isLoading,
      error: studyQuery.error,
    },
  });

  // ドリル学習定着バー（学習記録固有）。表示中のドリル学習記録を対象に取得する。
  const drillProgressMap = useTimelineDrillProgress(sectionId, displayed);

  return {
    displayed,
    isLoading,
    isFetchingNextPage,
    updateStudyRecordQueryCache: studyQuery.updateStudyRecordQueryCache,
    drillProgressMap,
  };
};
